export const ThirdPartyCasProvider = {
  885570000: "Achilles",
  885570001: "Constructionline"
}
